import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-width": "1.5",
      transform: "translate(1 1)"
    }, [
      _createElementVNode("circle", {
        cx: "8",
        cy: "4",
        r: "4"
      }),
      _createElementVNode("path", {
        "stroke-linecap": "round",
        d: "M15.998 16q.003-.246.002-.5c0-2.485-3.582-4.5-8-4.5s-8 2.015-8 4.5S0 20 8 20c2.231 0 3.84-.157 5-.437"
      })
    ], -1)
  ]))]))
}
export default { render: render }